import { useState } from 'react'
import PropTypes from 'prop-types'

import { getImageAssetPath, IMAGE_ASSET_PATH_FILTER_RESIZE_TO_LIMIT } from '@aytm/lib/common/assets'

import { resolveThumbSrc } from '@aytm/app/stats/page/question-views/components/lib/utils'

// components
import ImagePreview from '@aytm/app/stats/components/image-preview/ImagePreview'
import { pressable } from '@aytm/app/stats/components/lib/pressable'

// styles
import style from '@aytm/app/stats/page/question-views/ad/styles/Media.module.scss'

// The creative preview is sized from a fixed width, then capped by height so a tall
// creative still fits the block; the ratio fallback matches the standalone video question.
const PREVIEW_WIDTH = 660
const PREVIEW_MAX_HEIGHT = 470

const calcPreviewSize = ratio => {
  const height = PREVIEW_WIDTH * ratio

  return PREVIEW_MAX_HEIGHT < height
    ? { width: PREVIEW_MAX_HEIGHT / ratio, height: PREVIEW_MAX_HEIGHT }
    : { width: PREVIEW_WIDTH, height }
}

const Media = ({ id, mediaType, video, image }) => {
  const [showVideo, setShowVideo] = useState(false)

  if ('video' != mediaType) {
    return (
      <div className={style.image}>
        {image?.original == undefined ? (
          <img src="/images/external_survey/missing_image.png" alt="" />
        ) : (
          <ImagePreview
            className={style['image-box']}
            maxWidth={`${PREVIEW_WIDTH}px`}
            maxHeight={`${PREVIEW_MAX_HEIGHT}px`}
            imageUrl={image.original.url}
            previewUrl={getImageAssetPath({
              path: image.original.path,
              width: 600,
              height: 600,
              filter: IMAGE_ASSET_PATH_FILTER_RESIZE_TO_LIMIT,
              backgroundColor: 'white'
            })}
            // the author's scrolling flag lets the enlarged view scroll instead of shrinking
            allowScrolling={true === image.scrolling}
          />
        )}
      </div>
    )
  }

  if (video == undefined) {
    return (
      <div className={style.video}>
        <img src="/images/external_survey/missing_video.png" alt="" />
      </div>
    )
  }

  const { width, height } = calcPreviewSize(video.ratio || 0.5)
  const thumbnailUrl = resolveThumbSrc(video)

  return (
    <div className={style.video} style={{ minHeight: `${height}px` }}>
      {showVideo ? (
        <video
          id={`html5_id-${id}`}
          width={width}
          height={height}
          poster={thumbnailUrl}
          preload="auto"
          controls
          autoPlay
          controlsList="nodownload"
        >
          <source src={video.mp4File} type='video/mp4; codecs="avc1.42E01E, mp4a.40.2"' />
        </video>
      ) : (
        <div
          className={style['video-thumbnail']}
          aria-label="Play video"
          {...pressable(() => setShowVideo(true))}
          style={{ width: `${width}px`, height: `${height}px` }}
        >
          <img src={thumbnailUrl} width={width} height={height} alt="" />
          <img className={style['video-thumbnail-playback']} src="/images/ico/video-playback.png" alt="" />
        </div>
      )}
    </div>
  )
}

Media.displayName = 'Media'

Media.propTypes = {
  id: PropTypes.string,
  mediaType: PropTypes.string,
  video: PropTypes.object,
  image: PropTypes.object
}

export default Media
